module.exports = __webpack_public_path__ + "img/IconBloodSugarControl.62cb3097.svg";